module.exports = __webpack_public_path__ + "img/Foto_Press_Release_KreditPro_x_Bank_DBS_4.bd9721b3.jpeg";